import { combineReducers } from 'redux'


import { reducer as dataDeletion } from './data_deletion/slice'
import { reducer as domainControl } from './domain_control/slice'
import { reducer as samlSsoSettings } from './single_sign_on/slice'
import { reducer as userProvisioning } from './user_provisioning/slice'

export const reducer = combineReducers({
  dataDeletion,
  domainControl,
  samlSsoSettings,
  userProvisioning
})
